export class ReportParametersDefaultValue {
  salaryBatchId: number;
  employeeId: number;
  employmentId: number;
}
